/** @jsxImportSource @emotion/react */
import { Interpolation, Theme, css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";

const TabItem = styled.p<{ selected: boolean }>`
    color: ${(props) => (props.selected ? theme.primary500 : theme.neutral400)};
    font-size: 17px;
    font-weight: 700;
    padding: 10px;
    border-bottom: ${(props) => (props.selected ? `2px solid ${theme.primary500}` : "none")};

    cursor: pointer;
`;

const TabContainer = styled.div`
    display: flex;
    gap: 30px;
    align-items: center;
    border-bottom: 1px solid ${theme.neutral100};
`;

export type TabProps = {
    data: string[];
    styles?: {
        container?: Interpolation<Theme>;
    };
    selected?: string;
    onChange?: (value: string) => void;
};

const Tab = (tabData: TabProps) => {
    const { data, styles, selected = data[0], onChange } = tabData;
    return (
        <TabContainer css={styles?.container}>
            {data.map((item, index) => {
                return (
                    <TabItem key={index} onClick={() => onChange?.(item)} selected={selected === item}>
                        {item}
                    </TabItem>
                );
            })}
        </TabContainer>
    );
};

export default Tab;
